import React, { forwardRef, useRef } from 'react'
import { StyleSheet, TextInput } from 'react-native'
import DatePickerWeb from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

import { DS } from '@/design-system'
import { MINUTE_INTERVAL } from '@/constants'

const POPPER_CLASS = 'lounge-game-time-picker-popper'

interface LoungeTimePickerProps {
  value: Date
  onChange: (date: Date) => void
}

// biome-ignore lint/suspicious/noExplicitAny: react-datepicker input props
const CustomInput = forwardRef((props: any, ref) => {
  return <TextInput {...props} ref={ref} editable={false} style={styles.input} />
})

export function LoungeTimePicker({ value, onChange }: LoungeTimePickerProps) {
  const inputRef = useRef(null)

  return (
    <React.Fragment>
      <DatePickerWeb
        selected={value}
        onChange={(selectedDate) => {
          if (selectedDate) {
            onChange(selectedDate)
          }
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={MINUTE_INTERVAL}
        timeCaption="Time"
        dateFormat="h:mm aa"
        customInput={<CustomInput ref={inputRef} />}
        popperClassName={POPPER_CLASS}
      />
    </React.Fragment>
  )
}

const styles = StyleSheet.create({
  input: {
    height: 48,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 8,
    paddingLeft: 12,
    paddingRight: 12,
    borderColor: DS.palette['Global/Black'],
    borderWidth: 1,
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...DS.typography['Body Medium/Regular']
  }
})
